import React from 'react';
import { Accordion, Card } from 'react-bootstrap';

import { PluginComponent } from 'plugins';
import { SaleDocumentResponse } from 'types/SalesDocument';

import ToggleRow from './ToggleRow';
import SaleInfoRows from './SaleInfoRows';

import './index.scss';

type Props = {
  sale: SaleDocumentResponse;
  showName: boolean;
  isSaleFullyReturned: boolean;
  isExpanded: boolean;
  setExpanded(key: string, value: boolean): void;
};

const Panel: React.FC<Props> = ({
  sale,
  showName,
  isSaleFullyReturned,
  isExpanded,
  setExpanded,
}) => {
  const idAsString = String(sale.id);
  const active = isExpanded ? idAsString : '';

  return (
    <Accordion
      data-testid="previous-purchase-row"
      data-test-key={sale.number}
      activeKey={active}
    >
      <Card className="card-style">
        <Accordion.Toggle
          as={Card.Header}
          onClick={() => setExpanded(idAsString, !isExpanded)}
          eventKey={idAsString}
        >
          <ToggleRow
            sale={sale}
            showName={showName}
            isSaleFullyReturned={isSaleFullyReturned}
          />
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={idAsString}>
          <Card.Body className="no-padding">
            <PluginComponent hookname="UIRecentSalesInfoRow" props={sale}>
              <SaleInfoRows saleNumber={sale.number} saleRows={sale.rows} />
            </PluginComponent>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};
export default React.memo(Panel);
